import React, {useEffect, useState} from "react";
import TableList from "../../../component/TableList/TableList";
import FilterBoleto from "./FilterBoleto";
import {statusList} from "./lists/statusList";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import FileDownloadDoneIcon from '@mui/icons-material/FileDownloadDone';
import {normalizeTimestemp} from "../../../utils/normalizeTimestemp";
import sleep from "../../../utils/sleep";
import BoletoActions from "./BoletoActions";
import {useUser} from "../../../auth/AuthProvider";
import PopupExportBoleto from "./PopupExportBoleto";
import {numberWithPoints} from "../../../utils/numberWithPoints";
import DownloadBoleto from "../../../component/DownloadBoleto/DownloadBoleto";

export default function BoletoList({
                                       baseUrl, loadData,
                                       setLoadData, size, page,
                                       setTotalPages, setTotalElements,
                                       sort, setPage,
                                       filterDefault, type
                                   }) {

    const {user} = useUser()

    const [data, setData] = useState([])
    const [error, setError] = useState(false)


    const [filter, setFilter] = useState(filterDefault)
    useEffect(() => {
        setFilter(filterDefault)
        setLoadData(true)
    }, [type])

    const [idCopied, setIdCopied] = useState(null)

    const titles = user.isAdmin ? [
        'Evento',
        'Lote',
        'Parcela',
        'Valor',
        'Vencimento',
        'Status',
        'Nosso Número',
        'Código de Barras',
        'Banco'
    ] : [
        'Evento',
        'Lote',
        'Parcela',
        'Sacado(a)',
        'Vencimento',
        'Status',
        'Código de Barras'
    ]

    const copy = (item) => {
        const textField = document.createElement('textarea');
        textField.innerText = item.linhaDigitavel;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        document.body.removeChild(textField);
        setIdCopied(item.id);
    }

    useEffect(() => {
        if (idCopied) {
            sleep(3000).then(() => {
                setIdCopied(null)
            });
        }
    }, [idCopied])

    const listUrl = user.isAdmin ?
        `${baseUrl}/list` :
        `${baseUrl}/client/list`

    return (
        <>
            {user.isAdmin &&
                <FilterBoleto filter={filter} setFilter={setFilter} setLoadData={setLoadData} setPage={setPage}/>
            }
            <TableList
                titles={titles} baseUrl={listUrl}
                page={page} sort={sort} size={size}
                loadData={loadData}
                setTotalPages={setTotalPages} setTotalElements={setTotalElements}
                setData={setData} setLoadData={setLoadData} filter={filter}
                error={error} setError={setError} isFilterByUser={true}
            >
                {data.map((item) =>
                    <tr key={item.id}>
                        <td style={{
                            color: user.isAdmin ? 'default' :
                                item.tipoPapel === 'COMPRADOR' ? 'red' : 'green'
                        }}>{item.nomeEvento}</td>
                        <td style={{
                            color: user.isAdmin ? 'default' :
                                item.tipoPapel === 'COMPRADOR' ? 'red' : 'green'
                        }}>{item.numeroLote}</td>
                        <td>
                            {item.parcela}
                        </td>
                        {(user.isAdmin) &&
                            <td>R$ {numberWithPoints(item.valor)}</td>
                        }
                        {!(user.isAdmin) &&
                            <td>{item.sacado}</td>
                        }
                        <td>{normalizeTimestemp(item.dataVencimento)}</td>
                        <td>{statusList.filter(stt => stt.value === item.status)[0].label}</td>
                        <td>{item.nossoNumero ? item.nossoNumero : 'Não Tem'}</td>
                        <td>
                            <span
                                style={{maxWidth: '100px', wordWrap: 'break-word', cursor: 'pointer'}}
                                onClick={() => copy(item)}
                            >
                                {user.isAdmin ?
                                    `${item.linhaDigitavel.slice(0, 6)}...${item.linhaDigitavel.slice(-6)}` :
                                    'Copiar'
                                }
                                {item.id === idCopied ?
                                    <span className='text-success'>&nbsp;<FileDownloadDoneIcon/></span> :
                                    <>&nbsp;<ContentCopyIcon/></>
                                }
                            </span>
                        </td>
                        {(user.isAdmin) &&
                            <td>{item.banco}</td>
                        }
                        <td>
                            <span className='d-inline-block' style={{marginInline: '0%'}}>
                                <DownloadBoleto
                                    boletoId={item.id}
                                    filename={`boleto-parcela-${item?.parcela}-lote-${item?.numeroLote}-${item?.nomeEvento}`}
                                />
                                {user.isAdmin && <>
                                    &nbsp;&nbsp;
                                    <span className='d-inline-block'>
                                    <BoletoActions item={item} setLoadData={setLoadData}/>
                                </span>
                                </>}
                            </span>
                        </td>
                    </tr>
                )}
            </TableList>
            {!user.isAdmin && <>
                <br/>
                <ul className="legenda-boletos">
                    <li style={{color: 'red'}}>Boleto a pagar</li>
                    <li style={{color: 'green'}}>Boleto a receber</li>
                </ul>
            </>}
            <br/>
            {user?.isAdmin &&
                <PopupExportBoleto filter={filter}/>
            }
        </>
    )
}